module.exports = __webpack_public_path__ + "media/images/icon_list/return-26278e19252b36e60091d5d9840d8b3c.svg";